export default __webpack_public_path__ + "static/media/feather_copy_icon.cb74e074.svg";